import { useEffect } from 'react';
import { useParams } from 'react-router';
import UnidadForm from '../../components/unidades/UnidadForm';
import { useUnidadesStore, type ActualizarUnidad } from '../../stores/unidades/unidades.store';

const EditarUnidad = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const {
    current: unidad,
    actualizar,
    activar,
    desactivar,
    cargarPorId
  } = useUnidadesStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarUnidad) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <UnidadForm
      unidad={unidad}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarUnidad;
